/* Mounts the doc editor bundle on any [data-doc-editor] body.
 *
 * The editor is a separate bundle so pages without a doc never download Tiptap. A
 * <script src> in the page would not run after a boosted navigation
 * (.claude/docs/htmx-navigation.md, Gotchas), so this loader, which is in the main
 * bundle, injects it once and mounts each editor as it arrives. Before a swap that
 * removes an editor, and when the page is hidden for good, it flushes the pending save
 * and destroys the editor.
 */
(function () {
    // One id per tab. Saves send it, and the doc_updated broadcast echoes it back, so
    // the saving tab can ignore its own echo (acqs-ws.js does the same for acqs).
    var tabId = window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : String(Date.now()) + '-' + String(Math.random()).slice(2);
    var bundle = null;
    var editors = new Map();

    function loadBundle(src) {
        if (!bundle) {
            bundle = new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.onload = function () { resolve(window.HousesDocEditor); };
                script.onerror = function () { bundle = null; reject(new Error('Doc editor failed to load')); };
                document.head.appendChild(script);
            });
        }
        return bundle;
    }

    function mountAll() {
        document.querySelectorAll('[data-doc-editor]').forEach(function (el) {
            if (editors.has(el)) return;
            editors.set(el, null);
            loadBundle(el.dataset.docBundle).then(function (api) {
                // The body may have been swapped out while the bundle loaded.
                if (!el.isConnected || editors.get(el) !== null) return;
                editors.set(el, api.mount(el, {tabId: tabId}));
            }).catch(function () {
                // Left in the map so later htmx:load events do not retry and toast again.
                editors.set(el, false);
                SeeMe.toast.error('The editor did not load. Reload the page to edit.');
            });
        });
    }

    function teardown(within, keepalive) {
        editors.forEach(function (editor, el) {
            // A boosted navigation puts its loading skeleton in #page-content before the
            // response arrives (htmx-nav.js), so by beforeSwap the body may already be
            // detached. The editor still holds its text, so it can still flush.
            if (within && el.isConnected && !within.contains(el)) return;
            editors.delete(el);
            if (editor) editor.destroy({keepalive: keepalive});
        });
    }

    document.body.addEventListener('htmx:load', mountAll);
    document.body.addEventListener('htmx:beforeSwap', function (event) {
        if (event.detail.shouldSwap !== false) teardown(event.detail.target, false);
    });
    // The page is going away, so the last save has to outlive it. pagehide, not
    // beforeunload: beforeunload also fires for a download or a mailto: link, where the
    // page stays open with its editor gone.
    var hidden = false;
    window.addEventListener('pagehide', function () {
        hidden = editors.size > 0;
        teardown(null, true);
    });
    // Back can restore the page from the bfcache with the editors already destroyed and
    // htmx:load never firing again, so reload it instead of showing an empty body.
    window.addEventListener('pageshow', function (event) {
        if (event.persisted && hidden) window.location.reload();
    });
    mountAll();
})();
